export const A_CANDIDATE_MANDATORY_OPTIONS = [];

export const A_CANDIDATE_INITIAL_OPTIONS = [
  {
    label: "Candidate Name",
    value: "candidateSubmissionData.firstName",
    sort: true,
    sortValue: "candidate_submission_data.firstName",
    expand: true,
  },
  {
    label: "Candidate Nationality",
    value: "candidateSubmissionData.country",
    sort: true,
    sortValue: "candidate_submission_data.country",
  },
  {
    label: "Visa Status",
    value: "candidateSubmissionData.visaStatus",
    sort: true,
    sortValue: "candidate_submission_data.visaStatus",
  },
  {
    label: "Phone",
    value: "candidateSubmissionData.phone",
    sort: true,
    sortValue: "candidate_submission_data.phone",
  },
  {
    label: "Email",
    value: "candidateSubmissionData.email",
    sort: true,
    sortValue: "candidate_submission_data.email",
  },
  {
    label: "Experience",
    value: "candidateSubmissionData.totalExperience",
    sort: true,
    sortValue: "candidate_submission_data.totalExperience",
  }
];

export const R_CANDIDATE_MANDATORY_OPTIONS = [];

export const R_CANDIDATE_INITIAL_OPTIONS = [
  {
    label: "Candidate Name",
    value: "candidateSubmissionData.firstName",
    sort: true,
    sortValue: "candidate_submission_data.firstName",
    expand: true,
  },
  {
    label: "Candidate Nationality",
    value: "candidateSubmissionData.candidateNationality",
    sort: true,
    sortValue: "candidate_submission_data.candidateNationality",
  },
  {
    label: "Visa Status",
    value: "candidateSubmissionData.visaStatus",
    sort: true,
    sortValue: "candidate_submission_data.visaStatus",
  },
  {
    label: "Phone",
    value: "candidateSubmissionData.phone",
    sort: true,
    sortValue: "candidate_submission_data.phone",
  },
  {
    label: "Email",
    value: "candidateSubmissionData.email",
    sort: true,
    sortValue: "candidate_submission_data.email",
  },
  {
    label: "Experience",
    value: "candidateSubmissionData.totalExperience",
    sort: true,
    sortValue: "candidate_submission_data.totalExperience",
  }
];

export const JOB_MANDATORY_OPTIONS = [];

export const JOB_INITIAL_OPTIONS = [
  {
    label: "Job Title",
    value: "jobSubmissionData.jobTitle",
    sort: true,
    sortValue: "job_submission_data.jobTitle",
    expand: true,
  },
  {
    label: "Pulse Job ID",
    value: "jobSubmissionData.jobId",
    sort: true,
    sortValue: "job_submission_data.jobId",
    expand: true,
  },
  {
    label: "Location",
    value: "jobSubmissionData.country",
    sort: true,
    sortValue: "job_submission_data.country",
  },
  {
    label: "Job Type",
    value: "jobSubmissionData.jobType",
    sort: true,
    sortValue: "job_submission_data.jobType",
  },
  {
    label: "Recruiter(s)",
    value: "recruiter",
    sort: true,
    sortValue: "recruiter",
  }
];